import posthog from "posthog-js"

import analyticsConfig from "@/config/analytics"

import ErrorHandlerService from "@/services/ErrorHandler"

type UserData = {
	id: number
	instanceId: number
	name: string
	email: string
}

class AnalyticsService {
	setup (): void {
		try {
			if (this.canUsePosthog) {
				posthog.init(String(analyticsConfig.posthogKey), {
					api_host: analyticsConfig.posthogHost,
					autocapture: false,
					disable_session_recording: true,
					capture_pageview: false,
					capture_pageleave: false
				})
			}
		} catch (error) {
			ErrorHandlerService.handle(error as Error)
		}
	}

	setUserData (data: UserData): void {
		try {
			const {
				id,
				instanceId,
				name,
				email
			} = data

			if (this.canUsePosthog) {
				const formattedId = String(id)

				posthog.identify(formattedId, {
					instanceId,
					name,
					email
				})
			}
		} catch (error) {
			ErrorHandlerService.handle(error as Error)
		}
	}

	capture (event: string, properties?: Record<string, unknown>): void {
		try {
			if (this.canUsePosthog) {
				posthog.capture(event, properties)
			}
		} catch (error) {
			ErrorHandlerService.handle(error as Error)
		}
	}

	private get canUsePosthog (): boolean {
		return Boolean(analyticsConfig.posthogKey) && Boolean(analyticsConfig.posthogHost)
	}
}

export default new AnalyticsService()
